'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = require('lodash.isobject');

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = require('lodash.merge');

var _lodash4 = _interopRequireDefault(_lodash3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = function (oldState, newState) {
    var result = _extends({}, oldState);

    for (var key in newState) {
        if (!newState.hasOwnProperty(key)) {
            continue;
        }
        var value = newState[key];

        // Assign if we don't need to merge at all
        if (!result.hasOwnProperty(key)) {
            result[key] = (0, _lodash2['default'])(value) && !Array.isArray(value) ? (0, _lodash4['default'])({}, value) : value;
            continue;
        }

        var oldValue = result[key];

        if ((0, _lodash2['default'])(value) && !Array.isArray(value)) {
            result[key] = (0, _lodash4['default'])({}, oldValue, value);
        } else {
            result[key] = value;
        }
    }

    return result;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-storage-merger-simple/build/index.js
 ** module id = 675
 ** module chunks = 0 1
 **/